import React from 'react'
import { LinkLayout, LinkProps } from '../../../../../../Shared/Frontend/utils/links'
import { SharedBlockLayout } from '../../../modernBlocks/blocks/shared/sharedBlock.layout'
import { ParsedOverviewDetailItem } from '../widgets/overviewWidget.state'
import { StoryOverviewBlockClassNames } from './storyOverviewPage.state'
import { ImageSizesProps, ImageSourcesProps } from '../../../modernBlocks/modernBlocks.state'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import i18next from 'i18next'
import { QuoteBlockLayout } from '../../../modernBlocks/blocks/quoteBlock/quoteBlock.layout'

export const storyOverviewBlockClasses = (key?: number): StoryOverviewBlockClassNames => ({
  // BLOCK SPECIFIC
  teasersItem: 'teasers__item block--quote block--quote-image',
  teaser: `block__inner ${key && key % 2 ? 'white-background' : 'red-background'} ls-container ls-gutter ls-spacing--s`,
  teaserLink: 'quote-new quote--image',
  teaserContent: 'block__content',
  teaserTitle: 'quote__text quote--m',
  teaserCaption: 'quote__caption',
  teaserImage: 'block__image',
  teaserButton: 'block__button button button--primary',
})

export const StoryOverviewLayout = {
  Wrap: (props: { children?: React.ReactNode }): JSX.Element => {
    return (
      <section className="block block--news">
        <div className="block__layout">
          <div className="block__inner ls-container ls-gutter ls-spacing">
            <div className="block__content">{props.children}</div>
          </div>
        </div>
      </section>
    )
  },
  Teasers: (props: { children?: React.ReactNode }): JSX.Element => {
    const { children } = props
    return (
      <div className="block__teasers teasers teasers--stories">
        <ul className="teasers__list">{children}</ul>
      </div>
    )
  },
  TeaserVisual: (props: { image: ImageSizesProps['image'] }) => {
    return (
      <div className="block__visual">
        <div className="block__visual-inner fit-object">
          <SharedBlockLayout.ModernImageSrcSet
            image={props.image}
            lazyload={true}
            priority={undefined}
            classNames={getClassNameModern(storyOverviewBlockClasses(), 'teaserImage', '')}
            imageProportions={{
              width: '310',
              height: '206',
              sizes: '(min-width: 768px) 310px, 30vw',
            }}
          />
        </div>
        <svg
          className="block__mask block__mask--desk"
          height="356"
          viewBox="0 0 475 356"
          width="475"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            clipRule="evenodd"
            d="m475 347.32c-23.089 4.223-46.847 6.425-71.101 6.425-202.201 0-369.9931-153.059-401.89868-353.745h-2.00032v356h475z"
            fillRule="evenodd"
          />
        </svg>
        <svg
          className="block__mask block__mask--mob"
          height="210"
          viewBox="0 0 210 210"
          width="210"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <g>
            <path d="m105.093 189.008c-13.0135.002-25.8504-3.005-37.5032-8.785-11.6529-5.781-21.8047-14.177-29.6588-24.53s-13.1968-22.382-15.6087-35.141c-2.4119-12.76-1.8275-25.904 1.7074-38.4005l-19.93112-6.0255c-5.16591 17.9045-5.45366 36.86-.83357 54.912s13.98089 34.549 27.11779 47.79c13.1368 13.241 29.5746 22.747 47.6193 27.539s37.0439 4.697 55.0389-.277l-5.31-20.05c-7.375 2.013-14.992 3.012-22.638 2.968z" />
            <path d="m104.84.00001269c-8.8284-.00111959-17.6217 1.09653731-26.175 3.26728731l5.0077 20.1977c14.3939-3.6979 29.5153-3.5581 43.8373.4053s27.339 11.6101 37.736 22.1684l14.559-14.9403c-9.8-9.8574-21.473-17.6825-34.342-23.02105-12.869-5.33854-26.678-8.0841604-40.623-8.07733731z" />
          </g>
        </svg>
      </div>
    )
  },
  Teaser: (props: {
    index: number
    teaserKey: string
    title: string
    intro?: string
    link: LinkProps
    image?: ImageSizesProps['image']
    imageSources?: ImageSourcesProps['sources']
  }): JSX.Element => {
    const { title, intro, link, image, imageSources, teaserKey, index } = props
    console.log('image', image, imageSources)
    return (
      <li className={getClassNameModern(storyOverviewBlockClasses(), 'teasersItem', '')} key={teaserKey}>
        <article className={getClassNameModern(storyOverviewBlockClasses(index), 'teaser', '')}>
          <LinkLayout link={link} className={getClassNameModern(storyOverviewBlockClasses(), 'teaserLink', '')}>
            <div
              className={getClassNameModern(
                storyOverviewBlockClasses(),
                'teaserContent',
                image ? 'col-12 col-md-9 col-xl-10' : ''
              )}
            >
              {image ? (
                <div className="block__visual-inner fit-object">
                  <StoryOverviewLayout.TeaserVisual image={image} />
                </div>
              ) : (
                <SharedBlockLayout.SVGIcon
                  iconId="#icon--quote"
                  width="99px"
                  height="81px"
                  className="quote__icon quote__icon--top"
                />
              )}

              <div className="quote__inner">
                <div>
                  <div
                    className={getClassNameModern(storyOverviewBlockClasses(), 'teaserTitle', 'h2 text-secondary')}
                    dangerouslySetInnerHTML={{ __html: title }}
                  />

                  {intro && (
                    <div
                      className={getClassNameModern(
                        storyOverviewBlockClasses(),
                        'teaserCaption',
                        'figure-caption text-primary text-uppercase'
                      )}
                    >
                      <span>{intro}</span>
                    </div>
                  )}
                </div>

                <SharedBlockLayout.Clickable
                  id="storyTeaserPrimaryAction"
                  type="button"
                  link={{
                    ...link,
                    title: 'Lees verhaal',
                    isLinkExternal: false,
                  }}
                  classNames={getClassNameModern(storyOverviewBlockClasses(), 'teaserButton', 'btn btn-primary')}
                />
              </div>
            </div>
          </LinkLayout>
        </article>
      </li>
    )
  },
}
